<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main" v-loading="loading">
      <div class="header_title">
        <div class="number">订单编号：{{ detail.applyNum }}</div>
        <div class="time">下单时间：{{ detail.applyTime }}</div>
      </div>
      <div class="status">
        <img
          v-if="detail.state === 'AL02'"
          src="@/assets/loanOrder/icon_zhuangtai_cltj.png"
        />
        <img
          v-if="detail.state === 'AL03'"
          src="@/assets/loanOrder/icon_zhuangtai_sqtg.png"
        />
        <img
          v-if="detail.state === 'AL05'"
          src="@/assets/loanOrder/icon_zhuangtai_cltj.png"
        />
        <img
          v-if="detail.state === 'AL06'"
          src="@/assets/loanOrder/icon_zhuangtai_sqtg.png"
        />
        <img
          v-if="detail.state === 'AL07'"
          src="@/assets/loanOrder/icon_zhuangtai_zyth.png"
        />
        <img
          v-if="detail.state === 'AL08'"
          src="@/assets/loanOrder/icon_zhuangtai_yzy.png"
        />
        <p :class="detail.state === 'AL07' ? 'text-red' : ''">
          {{ detail.stateName }} <br />
          <span v-if="detail.state === 'AL07'">
            退回原因：{{ detail.failReason }}
          </span>
        </p>
      </div>
      <div class="block">
        <div class="plate">
          <div class="title">
            <h2 class="plate-title">机具信息</h2>
          </div>
        </div>
        <table class="table table-info">
          <tr>
            <td class="title">生产企业：</td>
            <td class="info">{{ detail.frimName }}</td>
            <td class="title">机具品牌：</td>
            <td class="info">{{ detail.brandName }}</td>
            <td class="title">机具类型：</td>
            <td class="info">{{ detail.machineryItem }}</td>
          </tr>
          <tr>
            <td class="title">机具型号：</td>
            <td class="info">{{ detail.prodModel }}</td>
            <td class="title">购机价格：</td>
            <td class="info">{{ detail.purchasePrice }}</td>
            <td class="title">补贴：</td>
            <td class="info">{{ detail.perSubsidyAmt }}</td>
          </tr>
          <tr>
            <td class="title">经销商：</td>
            <td class="info" colspan="5">{{ detail.agencyName }}</td>
          </tr>
        </table>
      </div>
      <div class="block">
        <div class="plate">
          <div class="title">
            <h2 class="plate-title">身份信息</h2>
          </div>
        </div>
        <table class="table table-info">
          <tr>
            <td class="tit" width="15%" rowspan="3">
              <div v-for="(item, index) in detail.fileList" :key="index">
                <template v-if="item.fileClassifCode == 'IDCARD_FRONT'">
                  <img :src="item.tFileDataDtos[0].picPath" alt="" />
                </template>
              </div>
            </td>
            <td class="title">姓名：</td>
            <td class="info">{{ detail.realName }}</td>
            <td class="title">身份证号：</td>
            <td class="info">{{ detail.idCard }}</td>
            <td class="title">手机号：</td>
            <td class="info">{{ detail.phone }}</td>
          </tr>
          <tr>
            <td class="title">身份证住址：</td>
            <td class="info" colspan="5">{{ detail.homeFullAddresses }}</td>
          </tr>
          <tr>
            <td class="title">现住址：</td>
            <td class="info" colspan="5">{{ detail.nowAddr }}</td>
          </tr>
        </table>
      </div>
      <div
        class="block"
        v-if="
          detail.state == 'AL05' ||
          detail.state == 'AL06' ||
          detail.state == 'AL07' ||
          detail.state == 'AL08' ||
          detail.state == 'AL09' ||
          detail.state == 'AL10' ||
          detail.state == 'AL11' ||
          detail.state == 'AL12' ||
          detail.state == 'AL13'
        "
      >
        <div class="plate">
          <div class="title">
            <h2 class="plate-title">发票信息</h2>
          </div>
        </div>
        <div
          class="item"
          v-for="(item, index) in detail.invoiceList"
          :key="index"
        >
          <div class="li">
            <img :src="item.invoiceUrl" alt="" />
          </div>
          <div class="li">
            <p>发票号：{{ item.invoiceNum }}</p>
            <p>购买方身份证号：{{ item.purchaserIdcard }}</p>
            <p>产品名称：{{ item.prodName }}</p>
            <p>金额：{{ item.purchasePrice }}元</p>
            <p>出厂编号：{{ item.machineryCode }}</p>
          </div>
          <div class="li">
            <p>购买方：{{ item.purchaserName }}</p>
            <p>销售方：{{ item.salerName }}</p>
            <p>规格型号：{{ item.prodModel }}</p>
            <p>开票日期：{{ item.invoiceDate }}</p>
            <p>发动机号：{{ item.engineNumber }}</p>
          </div>
        </div>
      </div>
      <div
        class="block"
        v-if="
          detail.state == 'AL05' ||
          detail.state == 'AL06' ||
          detail.state == 'AL07' ||
          detail.state == 'AL08' ||
          detail.state == 'AL09' ||
          detail.state == 'AL10' ||
          detail.state == 'AL11' ||
          detail.state == 'AL12' ||
          detail.state == 'AL13'
        "
      >
        <div class="plate">
          <div class="title">
            <h2 class="plate-title">
              一卡通银行卡<span>（发放农机补贴款的卡片）</span>
            </h2>
          </div>
        </div>
        <div class="card" v-for="(item, index) in detail.fileList" :key="index">
          <template v-if="item.fileClassifCode == 'PER_BORROW_BANK_CARD'">
            <p>卡号：{{ detail.bankAccount }}</p>
            <img :src="item.tFileDataDtos[0].picPath" alt="" />
          </template>
        </div>
      </div>
      <div
        class="block"
        v-if="
          detail.state == 'AL05' ||
          detail.state == 'AL06' ||
          detail.state == 'AL07' ||
          detail.state == 'AL08' ||
          detail.state == 'AL09' ||
          detail.state == 'AL10' ||
          detail.state == 'AL11' ||
          detail.state == 'AL12' ||
          detail.state == 'AL13'
        "
      >
        <div class="plate">
          <div class="title">
            <h2 class="plate-title">合影照片</h2>
          </div>
        </div>
        <div class="item">
          <div class="li" v-for="(item, index) in detail.fileList" :key="index">
            <template v-if="item.fileClassifCode == 'MAN_MACHINE'">
              <p>人机合影</p>
              <img :src="item.tFileDataDtos[0].picPath" alt="" />
            </template>
            <template v-if="item.fileClassifCode == 'IDCARD_NAMEPLATE'">
              <p>身份证+铭牌合影</p>
              <img :src="item.tFileDataDtos[0].picPath" alt="" />
            </template>
            <template v-if="item.fileClassifCode == 'MAN_IDCARD'">
              <p>人+身份证合影</p>
              <img :src="item.tFileDataDtos[0].picPath" alt="" />
            </template>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
export default {
  data() {
    return {
      id: '',
      detail: {},
      loading: false,
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getOrderDetailById()
  },
  methods: {
    /**
     * @description: 获取订单详情
     * @Author: quwandong
     * @Date: 2022-05-18 10:21:21
     */
    async getOrderDetailById() {
      try {
        this.loading = true
        const res = await this.$http.loanOrder.getOrderDetailById({
          applyId: this.id,
        })
        if (res.status == 1) {
          this.detail = res.data.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.plate-title {
  @include plate-title;
  color: black;
  margin-top: 10px;
  span {
    color: #acacac;
    font-size: 14px;
  }
}
.main {
  padding-top: 20px !important;
  .card {
    img {
      height: 189px;
      margin-top: 10px;
    }
  }
  .header_title {
    color: #5f6868;
    display: flex;
    font-size: 16px;
    .time {
      margin-left: 20px;
    }
  }
  .status {
    display: flex;
    align-items: center;
    margin-top: 20px;
    img {
      height: 48px;
    }
    p {
      color: #018388;
      font-weight: bold;
      font-size: 22px;
      margin-left: 7px;

      &.text-red {
        color: #ff0101;

        span {
          font-size: 16px;
        }
      }
    }
  }
  .item {
    display: flex;
    margin-bottom: 20px;
    .li {
      margin-left: 70px;
      color: #333333;
      img {
        height: 180px;
      }
      p {
        line-height: 35px;
      }
    }
    .li:nth-child(1) {
      margin-left: 0;
    }
  }
}
.table-info {
  width: 100%;
  border: 1px solid #e9edf7;
  border-collapse: collapse;
  // margin-bottom: 20px;
  position: relative;
  tr {
    width: 100%;
    img {
      height: 122px;
    }
    td {
      height: 50px;
      padding: 8px;
      font-size: 16px;
      border-bottom: 1px solid #e9edf7;
      box-sizing: border-box;
      &.tit {
        div {
          display: flex;
          justify-content: center;
        }
      }
      &.title {
        width: 120px;
        text-align: right;
        color: #838383;
        background: #f8f9fc;
        box-sizing: border-box;
      }
      &.info {
        width: 20%;
        color: #333333;
        .ul {
          display: flex;
          .item {
            text-align: center;
            margin-left: 30px;
            cursor: pointer;
            img {
              height: 40px;
            }
          }
        }
        .open {
          padding: 5px 10px 5px 10px;
          border: 1px solid #eeeeee;
          cursor: pointer;
        }
      }
    }
  }
}
::v-deep .el-dialog__headerbtn {
  font-size: 28px !important;
}
</style>